import { ChaveValor } from '../chave-valor.model';

export class CargosEnum {

  lista: ChaveValor[];

  constructor() {
    this.lista = [
      { id: 1, nome: '1 - Agente Administrativo II' },
      { id: 40, nome: '40 - Biomedico' },
      { id: 41, nome: '41 - Educador Social' },
      { id: 42, nome: '42 - Profissional de E. Fisica' },
      { id: 43, nome: '43 - Tecnico em Farmacia' },
      { id: 44, nome: '44 - Turismologo' },
      { id: 45, nome: '45 - Tradutor E I. De L. De Sin' },
      { id: 46, nome: '46 - Psicopedagogo' },
      { id: 101, nome: '101 - Auxiliar de Operacoes I' },
      { id: 103, nome: '103 - Auxiliar de Limpeza Publi' },
      { id: 106, nome: '106 - Agente Auxiliar de Obras' },
      { id: 107, nome: '107 - Agente de Obras I' },
      { id: 108, nome: '108 - Agente de Obras' },
      { id: 109, nome: '109 - Agente Auxiliar de Manute' },
      { id: 110, nome: '110 - Agente de Manutencao I' },
      { id: 111, nome: '111 - Agente de Manutencao' },
      { id: 112, nome: '112 - Motorista de Caminhao' },
      { id: 113, nome: '113 - Operador de Maquina Rodov' },
      { id: 114, nome: '114 - Agente Redutor de Danos' },
      { id: 116, nome: '116 - Agente Administrativo Aux' },
      { id: 117, nome: '117 - Agente Administrativo I' },
      { id: 118, nome: '118 - Agente Administrativo' },
      { id: 119, nome: '119 - Auxiliar de Processamento' },
      { id: 120, nome: '120 - Agente de Processamento I' },
      { id: 121, nome: '121 - Agente de Processamento I' },
      { id: 122, nome: '122 - Programador de Computador' },
      { id: 123, nome: '123 - Analista de Sistemas' },
      { id: 124, nome: '124 - Fiscal Municipal I' },
      { id: 125, nome: '125 - Fiscal Municipal II' },
      { id: 126, nome: '126 - Auditor Fiscal Municipal' },
      { id: 127, nome: '127 - Tecnico I' },
      { id: 128, nome: '128 - Tecnico II' },
      { id: 129, nome: '129 - Tecnico em Contabilidade' },
      { id: 130, nome: '130 - Tesoureiro' },
      { id: 131, nome: '131 - Contador' },
      { id: 132, nome: '132 - Terapeuta Ocupacional' },
      { id: 135, nome: '135 - Arquivista' },
      { id: 136, nome: '136 - Bibliotecario' },
      { id: 137, nome: '137 - Administrador' },
      { id: 138, nome: '138 - Economista' },
      { id: 139, nome: '139 - Procurador Juridico' },
      { id: 141, nome: '141 - Auxiliar em Assistencia' },
      { id: 142, nome: '142 - Agente em  Assistencia' },
      { id: 143, nome: '143 - Enfermeiro' },
      { id: 144, nome: '144 - Assistente Social' },
      { id: 145, nome: '145 - Psicologo' },
      { id: 146, nome: '146 - Farmaceutico - Bioquimico' },
      { id: 147, nome: '147 - Odontologo' },
      { id: 148, nome: '148 - Medico Clinico Geral' },
      { id: 149, nome: '149 - Fisioterapeuta' },
      { id: 150, nome: '150 - Fonoaudiologo' },
      { id: 151, nome: '151 - Tecnico em Agropecuaria' },
      { id: 152, nome: '152 - Medico Ginecologista' },
      { id: 160, nome: '160 - Nutricionista' },
      { id: 161, nome: '161 - Auxiliar de Servicos Tecn' },
      { id: 162, nome: '162 - Agente Tecnico' },
      { id: 163, nome: '163 - Tecnico em Obras' },
      { id: 164, nome: '164 - Arquiteto' },
      { id: 165, nome: '165 - Engenheiro Civil' },
      { id: 166, nome: '166 - Engenheiro Eletricista' },
      { id: 167, nome: '167 - Engenheiro Mecanico' },
      { id: 168, nome: '168 - Engenheiro Agronomo' },
      { id: 169, nome: '169 - Engenheiro Florestal' },
      { id: 170, nome: '170 - Medico Veterinario' },
      { id: 171, nome: '171 - Zootecnista' },
      { id: 172, nome: '172 - Tecnico em Radiologia' },
      { id: 173, nome: '173 - Medico Endocrinologista' },
      { id: 174, nome: '174 - Tecnico em Fiscalizacao' },
      { id: 175, nome: '175 - Biologo' },
      { id: 176, nome: '176 - Geografo' },
      { id: 177, nome: '177 - Agente de Fiscalizacao I' },
      { id: 178, nome: '178 - Agente de Fiscalizacao II' },
      { id: 179, nome: '179 - Guarda Municipal' },
      { id: 180, nome: '180 - Farmaceutico' },
      { id: 181, nome: '181 - Auxiliar de Servicos Gerais I' },
      { id: 182, nome: '182 - Auxiliar de Servicos Gerais' },
      { id: 183, nome: '183 - Telefonista' },
      { id: 184, nome: '184 - Vigilante' },
      { id: 185, nome: '185 - Motorista de Autom e Util' },
      { id: 187, nome: '187 - Medico Cirurgia Geral' },
      { id: 188, nome: '188 - Medico Cardiologista' },
      { id: 189, nome: '189 - Medico Dermatologista' },
      { id: 190, nome: '190 - Medico Oftalmologista' },
      { id: 191, nome: '191 - Medico Gineco. e Obstetra' },
      { id: 192, nome: '192 - Medico Psiquiatra' },
      { id: 193, nome: '193 - Medico Pediatra' },
      { id: 194, nome: '194 - Medico Radiologista' },
      { id: 195, nome: '195 - Medico Patologista' },
      { id: 196, nome: '196 - Medico Neurologista' },
      { id: 197, nome: '197 - Medico do Trabalho' },
      { id: 198, nome: '198 - Medico Traumatologista' },
      { id: 200, nome: '200 - Medico Anestesista' },
      { id: 201, nome: '201 - Medico de Saude da Famili' },
      { id: 202, nome: '202 - Enfermeiro de S da Fam.' },
      { id: 203, nome: '203 - Cirurgiao Dentista de S d' },
      { id: 204, nome: '204 - Tec. Enfermagem de S da F' },
      { id: 205, nome: '205 - Agente Administrativo Esc' },
      { id: 206, nome: '206 - Auxiliar de Serv Gerais de Escola' },
      { id: 207, nome: '207 - Merendeira de Escola' },
      { id: 325, nome: '325 - Esp.em Educ:orientacao ed' },
      { id: 337, nome: '337 - Professor N. E.' },
      { id: 338, nome: '338 - Professor - E. Infantil -' },
      { id: 339, nome: '339 - Professor Ed. Inf. S. Ini' },
      { id: 346, nome: '346 - Professor em Metalurgia' },
      { id: 349, nome: '349 - Professor em Mecanica' },
      { id: 352, nome: '352 - Professor em Eletricidade' },
      { id: 354, nome: '354 - Professor de Desenho Tecn' },
      { id: 362, nome: '362 - Professor - Anos Iniciais' },
      { id: 363, nome: '363 - Professor - Ciencias' },
      { id: 364, nome: '364 - Professor - Educacao Arti' },
      { id: 365, nome: '365 - Professor - Educacao Espe' },
      { id: 366, nome: '366 - Professor - Educacao Fisi' },
      { id: 367, nome: '367 - Professor - Estudos Socia' },
      { id: 368, nome: '368 - Professor - Geografia' },
      { id: 369, nome: '369 - Professor - Historia' },
      { id: 370, nome: '370 - Professor - Ingles' },
      { id: 371, nome: '371 - Professor - Portugues' },
      { id: 372, nome: '372 - Professor - Matematica' },
      { id: 373, nome: '373 - Professor - Series Inicia' },
      { id: 374, nome: '374 - Professor de Musica' },
      { id: 375, nome: '375 - Professor - Pedagogia' },
      { id: 376, nome: '376 - Professor - Espanhol' },
      { id: 377, nome: '377 - Professor Educ. Inf. - Creche' },
      { id: 378, nome: '378 - Professor de Teatro' },
      { id: 805, nome: '805 - Auxiliar de Enfermagem' },
      { id: 806, nome: '806 - Aux. de Cons. Dent. S da' },
      { id: 825, nome: '825 - Pedagoga' },
      { id: 980, nome: '980 - Administrador' },
      { id: 999, nome: '999 - Agente Comuntario de Saude' },
      { id: 1020, nome: '1020 - Auxiliar de Operacoes II' },
      { id: 9000, nome: '9000 - Atendente de Consult Den' },
      { id: 9001, nome: '9001 - Auxiliar de Farmacia' },
      { id: 9002, nome: '9002 - Auxiliar de Laboratorio' },
      { id: 9003, nome: '9003 - Tecnico em Enfermagem' },
      { id: 9006, nome: '9006 - Tecnico em Saude Mental' },
      { id: 9007, nome: '9007 - Tecnico em Seg. do Traba' },
      { id: 9011, nome: '9011 - Desenhista de Comp. Graf' },
      { id: 9013, nome: '9013 - Medico Auditor' },
      { id: 9014, nome: '9014 - Medico Epidemiologista' },
      { id: 9015, nome: '9015 - Medico Infectologista' },
      { id: 9016, nome: '9016 - Sociologo' },
      { id: 9017, nome: '9017 - Engenheiro Quimico' },
      { id: 9018, nome: '9018 - Engenheiro de Seguranca' },
      { id: 9019, nome: '9019 - Farmaceutico Industrial' },
      { id: 9020, nome: '9020 - Fisico' },
      { id: 9021, nome: '9021 - Quimico Industrial' },
      { id: 9022, nome: '9022 - Farmac.-Tecnologo de Alimentos' },
      { id: 9023, nome: '9023 - Geologo' },
      { id: 9024, nome: '9024 - Auxiliar de Servicos Gerais II' },
      { id: 9025, nome: '9025 - Medico Acupunturista' },
      { id: 9026, nome: '9026 - Medico Gastroenterologis' },
      { id: 9027, nome: '9027 - Medico Hematolog-hemoter' },
      { id: 9028, nome: '9028 - Medico Homeopata' },
      { id: 9029, nome: '9029 - Medico Plantonista de Ur' },
      { id: 9030, nome: '9030 - Medico Otorrinolaringolo' },
      { id: 9031, nome: '9031 - Medico Pneumologista' },
      { id: 9032, nome: '9032 - Medico Pneumopediatra' },
      { id: 9033, nome: '9033 - Medico Proctologista' },
      { id: 9034, nome: '9034 - Medico Reumatologista' },
      { id: 9035, nome: '9035 - Medico Urologista' },
      { id: 9036, nome: '9036 - Medico Angiologista' },
      { id: 9010, nome: '9010 - Agente de Saude Pub e Vig Amb' }
    ];
  }
}
